import React, { Component } from "react";

import ManagedCustomerRow from "./ManagedCustomerRow";
import ManagedCustomerView from "./ManagedCustomerView";
import { userService } from "../../Services/UserService.js";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles, withStyles } from '@material-ui/core/styles';

class CustomerList extends Component {
	

	constructor(props) {
        super(props);
		this.state= {
			page: 0,
			rowsPerPage: 25
		}
		
		this.handleFirstPageButtonClick=this.handleFirstPageButtonClick.bind(this);
		this.handleBackButtonClick=this.handleBackButtonClick.bind(this);
		this.handleNextButtonClick=this.handleNextButtonClick.bind(this);
		this.handleLastPageButtonClick=this.handleLastPageButtonClick.bind(this);
		this.handleChangePage=this.handleChangePage.bind(this);
		this.handleChangeRowsPerPage=this.handleChangeRowsPerPage.bind(this);
		this.removeCustomer=this.removeCustomer.bind(this);
		this.orderCustomers=this.orderCustomers.bind(this);
		this.setManagedCustomers=this.setManagedCustomers.bind(this);
    }
	
	handleFirstPageButtonClick(event) {
		this.setState({page: 0});
	}
	
	handleBackButtonClick(event) {
		this.setState({page: this.state.page-1});
	}
	
	handleNextButtonClick(event) {
		this.setState({page: (this.state.page+1 > Math.max(0, Math.ceil(Object.keys(this.props.customers).length / this.state.rowsPerPage) - 1)) ? this.state.page : this.state.page+1});
	}
	
	handleLastPageButtonClick(event) {
		this.setState({page: Math.max(0, Math.ceil(Object.keys(this.props.customers).length / this.state.rowsPerPage) - 1)});
	}
  
	handleChangePage(event, newPage) {
		this.setState({page: newPage});
	}
	
	handleChangeRowsPerPage(event) {
		this.setState({ rowsPerPage: parseInt(event.target.value, 10),
						page: 0
		});
	}
	
	removeCustomer(custIdRemove){
		let filtered = this.props.customers.filter(function(value, index, arr){ return (value.id != custIdRemove);});
		let str = filtered.reduce((acc, cur, idx) => acc + (idx>0 ? ",":"") + cur.id, "");
		userService.setManagedCustomers(this.props.userId, str);
		this.props.handleManagedCustomers(str);
	}
	
	setManagedCustomers(managedCustomersList){
		userService.setManagedCustomers(this.props.userId, managedCustomersList);
		this.props.handleManagedCustomers(managedCustomersList);
	}
	
	orderCustomers(a, b){
		return this.props.customers[a].name.localeCompare(this.props.customers[b].name);
	}

	render() {
//		console.log('render [CustomerList STATE]: ' + JSON.stringify(this.state));
//		console.log('render [CustomerList PROPS.customers.length]: ' + JSON.stringify(this.props.customers.length));
		const rows = [];
		if(typeof this.props.customers !== 'undefined'){
			var keys = Object.keys(this.props.customers).sort(this.orderCustomers);
			if(keys.length>0){
				for (var j = this.state.rowsPerPage*this.state.page; (j < (this.state.rowsPerPage*(this.state.page+1))) && (j<keys.length); j++) {
//					console.log("Order: " +j);
					var customer = this.props.customers[keys[j]];
					rows.push(
					<ManagedCustomerRow
						key={customer.id}
						id={customer.id}
						remove={this.removeCustomer}
						name={customer.name}/>
//						actions={this.props.customerActions}/>
					);
				}
			}
		}
		
		let managedCustomerView = "";
		//if(this.props.role === "CUSTOMER" && this.props.relatedUsers!=null){
			managedCustomerView = <ManagedCustomerView
									userId = {this.props.id}
									customers = {this.props.allCustomers}
									managedCustomers = {this.props.customers}
									setManagedCustomers = {this.setManagedCustomers}/>
		//}
		
		//<h5>Managed customers:<Tooltip title="Add"><AddIcon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}} onClick={() => { }} /></Tooltip></h5>
		return (
		<div className="content">
		  <h5>Managed customers: {managedCustomerView}</h5>
		  <Table className="lst">
		    <TableHead>
		      <TableRow>
		        <TableCell>Id</TableCell>
				<TableCell>Customer</TableCell>
				<TableCell>Actions</TableCell>
		      </TableRow>
		    </TableHead>
		    <TableBody>{rows}</TableBody>
		    <TableFooter>
              <TableRow>
                <TablePagination
                  colSpan={3}
                  count={keys.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
		  </Table>
		</div>
		);
  }
};

export default CustomerList;